import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.campaigns, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_CAMPAIGNS_SNAPSHOT:
      return {
        ...state,
        data: action.campaigns,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    case ActionTypes.RECEIVE_CAMPAIGNS_TOTAL_COUNT_SNAPSHOT:
      return { ...state, totalCount: action.totalCount };
    case ActionTypes.SET_CAMPAIGNS_SEARCH_CRITERIA:
      return { ...state, ...action.searchCriteria };
    case ActionTypes.SET_CAMPAIGNS_COLUMN_VISIBILITY: {
      return {
        ...state,
        columns: state.columns.map(column => {
          if (column.id === action.column.id) {
            return { ...column, visible: action.column.visible ? false : true };
          }
          return column;
        })
      };
    }
    default:
      return state;
  }
};
